<template>
  <div ref="imageWrapper" class="w-full relative">
    <img
      :src="afterImage"
      class="w-full h-full object-cover object-center user-select-none"
      :loading="lazy ? 'lazy' : 'auto'"
      alt="после"
      :draggable="false"
    />
    <img
      class="absolute top-0 bottom-0 left-0 right-0 min-w-full min-h-full object-cover object-left user-select-none"
      :src="beforeImage"
      alt="До"
      :loading="lazy ? 'lazy' : 'auto'"
      :style="`clip-path: inset(0 ${100 - compareWidth}% 0 0)`"
      :draggable="false"
    />
    <input
      v-model="compareWidth"
      :step="step"
      class="absolute -translate-y-2/4 z-[999] w-full h-[50px] cursor-ew-resize opacity-0 top-2/4 inset-x-0"
      type="range"
      min="0"
      max="100"
      tabindex="-1"
    />
    <div
      class="flex items-center justify-center absolute h-full -translate-x-2/4 -translate-y-2/4 z-[5] top-2/4"
      :style="{ left: `${compareWidth}%` }"
    >
      <div class="flex text-white w-8 h-8 rounded-full bg-primary m-auto">
        <IconSeparatorVertical class="m-auto" />
      </div>
      <span
        class="bg-primary content-[''] absolute w-0.5 h-full z-[4] pointer-events-none select-none top-0"
      />
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

import { IconSeparatorVertical } from '@tabler/icons-vue'

const props = defineProps({
  value: {
    type: Number,
    default: 50,
  },
  beforeImage: {
    type: String,
    default: '',
  },
  afterImage: {
    type: String,
    default: '',
  },
  step: {
    type: Number,
    default: 0.1,
  },
  lazy: {
    type: Boolean,
    default: true,
  },
})

const width = ref(null)
const compareWidth = ref(props.value)

const imageWrapper = ref(null)

function resizeHandler() {
  width.value = imageWrapper.value.getBoundingClientRect().width
}

onMounted(() => {
  width.value = imageWrapper.value.getBoundingClientRect().width
  window.addEventListener('resize', resizeHandler)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', resizeHandler)
})
</script>
